import styled from '@emotion/styled';

import { su } from '../../theme/functions/su';

export const HeaderActionsContainer = styled.div`
  display: flex;
  padding-inline-start: ${su(4)};
  align-items: center;

  /* @emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason */
  > :not(:last-child) {
    margin-inline-end: ${su(2)};
  }
`;
